import React from 'react';
import Empty from 'src/components/Empty';
import Callout from 'src/components/InformationCallout/Callout';
import { ServiceRequestDashboardTable } from 'src/pages/ServiceRequests/components/ServiceRequestDashboardTable';
import { ServiceRequestDashboardActions } from 'src/pages/ServiceRequests/components/ServiceRequestDashboardActions';
import ServiceRequestDashboardToolbar from 'src/pages/ServiceRequests/components/ServiceRequestDashboardToolbar/ServiceRequestDashboardToolbar';
import { DownloadCSVAndPDFParserOverlay } from 'src/utils/DownloadCSVAndPDFParserOverlay/DownloadCSVAndPDFParserOverlay';
import 'src/pages/ServiceRequests/ServiceRequestDashBoardTable.scss';
import './ContactServiceRequests.scss';
import { UseContactServiceRequestsOrchestratorReturn } from './CustomHooks/ContactServiceRequests/useContactServiceRequestsOrchestrator';

export interface ContactServiceRequestsProps {
  orchestrator: UseContactServiceRequestsOrchestratorReturn;
  navigateTo: string;
  navLabel: string;
  forceLoading?: boolean;
  persistKey?: string;
}

const ContactServiceRequests = ({
  orchestrator,
  navigateTo,
  navLabel,
  forceLoading = false,
  persistKey,
}: ContactServiceRequestsProps) => {
  const isInitialLoading: boolean =
    forceLoading ||
    (orchestrator.isLoading && orchestrator.serviceRequests.length === 0);

  const showEmpty: boolean =
    !forceLoading &&
    !orchestrator.isLoading &&
    orchestrator.visibleServiceRequests.length === 0;

  return (
    <div>
      <DownloadCSVAndPDFParserOverlay
        isOpen={orchestrator.isDownloadOverlayOpen}
        onClose={orchestrator.closeDownloadOverlay}
        onDownloadCSV={orchestrator.onDownloadCSV}
        isCSVLoading={orchestrator.isCSVLoading}
        onDownloadPDF={orchestrator.onDownloadPDF}
        isPDFLoading={orchestrator.isPDFLoading}
      />
      <div className="contact-sr-callout">
        <Callout
          variant="info"
          title="Missing a service request you expected to see?"
          subtitle="A Property Developer or Admin may have set it to internal, which hides it from this list. To bring it back, open the Service Request dashboard, find the ticket, and change its visibility back to external."
        />
      </div>
      <ServiceRequestDashboardToolbar>
        <ServiceRequestDashboardActions
          searchString={orchestrator.searchQuery}
          onChangeSearchString={orchestrator.setSearchQuery}
          showResolved={orchestrator.showResolvedOnly}
          onShowResolved={orchestrator.toggleShowResolved}
          onShowColumnSelectionDialog={orchestrator.openColumnSelectionDialog}
          onDownload={orchestrator.openDownloadOverlay}
          hideBulkActions={true}
        />
      </ServiceRequestDashboardToolbar>
      {showEmpty ? (
        <Empty
          direction="ttb"
          headline="No service requests for this contact"
          strapline="Service requests reported by or assigned to this contact will be listed here."
          image={null}
          searchIsActive={orchestrator.searchQuery !== ''}
        />
      ) : (
        <ServiceRequestDashboardTable
          serviceRequests={orchestrator.visibleServiceRequests}
          selectedServiceRequests={orchestrator.selectedIds}
          onSelectServiceRequest={orchestrator.toggleSelection}
          onSelectGroup={orchestrator.toggleSelectionBatch}
          onSelectAll={orchestrator.toggleSelectAllVisible}
          allSelected={orchestrator.allVisibleSelected}
          onDeleteGroup={() => undefined}
          onRemoveFromGroup={() => undefined}
          navigateTo={navigateTo}
          navLabel={navLabel}
          loading={isInitialLoading}
          showColumnSelectionDialog={orchestrator.showColumnSelectionDialog}
          onCloseColumnSelectionDialog={orchestrator.closeColumnSelectionDialog}
          persistKey={persistKey}
        />
      )}
    </div>
  );
};

export default ContactServiceRequests;